// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".scroll[data-v-3fbc955e]{background:hsla(0,0%,100%,.3);display:flex;height:20px;justify-content:space-between}.scroll__left[data-v-3fbc955e],.scroll__right[data-v-3fbc955e]{background:#6c7684;cursor:col-resize;height:20px;position:relative;width:2px}.scroll__left[data-v-3fbc955e]:after,.scroll__right[data-v-3fbc955e]:after{background:transparent;content:\"\";cursor:col-resize;height:40px;left:-15px;position:absolute;right:-15px;top:-10px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
